import getFromAddress from '../utils/getFromAddress';
import { getComposeEvent } from 'owa-calendar-compose-store-manager';
import { initializeMailTips } from 'owa-calendar-compose-form-actions/lib/actions/initializeMailTips';
import { orchestrator } from 'satcheljs';
import { updateMailtips } from 'owa-mail-tips';
import getAttendeesAndLocationsAsEmailAddresses from '../utils/getAttendeesAndLocationsAsEmailAddresses';

export default orchestrator(initializeMailTips, actionMessage => {
    const event = getComposeEvent(actionMessage.formId);
    updateMailtips(
        actionMessage.formId,
        getFromAddress(actionMessage.formId, event.Organizer),
        getAttendeesAndLocationsAsEmailAddresses(event).map(
            emailAddressWrapper => emailAddressWrapper.EmailAddress
        )
    );
});
